// @param tups: Array of tuples containing the key/value pairs
//  for the form data
export function makeFormData(tups = []) {
  const formData = new FormData();
  addFormData(formData, tups);
  return formData;
}

// @param data: a FormData instance
// @param tups: Array of tuples containing the key/value pairs
//  for the form data. If a key contains multiple values, as in
//  the case of a multiselect form field, the value should be an iterable
//  of values for that key.
export function addFormData(formData, tups) {
  tups.forEach(([key, value]) => {
    if (Array.isArray(value)) {
      for (const val of value) {
        formData.append(key, val);
      }
    } else if (value === null) {
      /*
       * null in JS converts to 'null' in formdata, which Python then
       * reasonably interprets as a string, which we don't want, so
       * do nothing in this case.
       */
    } else {
      formData.append(key, value);
    }
  });
}

// Submits an existing html form to POST cached checkbox parameters.
//
// @param formSelector: selector of an existing html form on the page
// @param checkboxes: Checkboxes instance
// @param name: specify a different name attributes for the inputs
// @param extra: array of tuples for extra params to add to the POST data
export function submitCheckboxForm(
  formSelector,
  checkboxes,
  name = undefined,
  extra = undefined,
) {
  const form = $(formSelector);
  form.find('.input-container').html(checkboxes.getFormHtml(name, extra));
  form.submit();
}

export function makeCheckedInput(key, value) {
  return `
    <input
      name="${key}"
      value="${value}"
      type="checkbox"
      checked="checked" />
  `;
}
